import React, { useState } from 'react';
import { auth } from '../firebase';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword,signOut } from 'firebase/auth';
import { useUser } from '../context/UserContext';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { GlobalContext } from "../context/GlobalContext";
const LoginSignup = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [username,setusername]=useState('');
   const { setUsername } = useUser();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { resetWatchlist } = useContext(GlobalContext);
  const handleLogout = async () => {
    await signOut(auth);
    setUsername(null);
    resetWatchlist(); // clear watchlist
    navigate('/'); // optional: redirect to watchlist
};
  const handleSubmit = async (e) => {
    setUsername(username);
    e.preventDefault();
    setError('');

    try {
      if (isLogin) {
        await signInWithEmailAndPassword(auth, email, password);
      } else {
        await createUserWithEmailAndPassword(auth, email, password);
      }
      navigate('/');
    } catch (err) {
      setError(err.message);
    }
  };
  return (
    <div style={styles.container}>
      <h2>{isLogin ? 'Login' : 'Sign Up'}</h2>
      <form onSubmit={handleSubmit} style={styles.form}>
        <input
          type="username"
          placeholder="username"
          value={username}
          required
          onChange={(e) => setusername(e.target.value)}
          style={styles.input}
        />
        <input
          type="email"
          placeholder="Email"
          value={email}
          required
          onChange={(e) => setEmail(e.target.value)}
          style={styles.input}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          required
          onChange={(e) => setPassword(e.target.value)}
          style={styles.input}
        />
              

        <button type="submit" style={styles.button}>
          {isLogin ? 'Login' : 'Sign Up'}
        </button>
      </form>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <p>
        {isLogin ? "Don't have an account?" : "Already have an account?"}{' '}
        <button onClick={() => setIsLogin(!isLogin)} style={styles.linkBtn}>
          {isLogin ? 'Sign Up' : 'Login'}
        </button>
      </p>
      <button onClick={handleLogout} style={{color:"red"}}>logout</button>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '400px',
    margin: '150px auto',
    padding: '10px 40px',
    backgroundColor: '#111',
    borderRadius: '10px',
    color: 'white',
    textAlign: 'center',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
  input: {
    padding: '10px',
    borderRadius: '5px',
    border: '1px solid #444',
    backgroundColor: '#222',
    color: 'white',
  },
  button: {
    padding: '10px',
    borderRadius: '5px',
    backgroundColor: 'white',
    color: 'black',
    cursor: 'pointer',
    fontWeight: 'bold',
  },
  linkBtn: {
    background: 'none',
    color: '#00f',
    border: 'none',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  error: {
    color: 'red',
    marginTop: '10px',
  },
};

export default LoginSignup;
